import React from 'react';
import logo from '../assets/logo.jpg';
import { BRAND } from '../config/brand.js';

// Shown for the whole site when the backend cannot be reached
export default function ComingSoon({ onRetry, checking }) {
  return (
    <main className="soon soon--page">
      <img src={logo} alt={BRAND} className="soon__logo" />
      <p className="eyebrow">Women's clothing and handbags</p>
      <h1 className="soon__title">Coming Soon</h1>
      <p className="soon__text">Our online store is getting ready. Please check back shortly.</p>
      {onRetry && (
        <button type="button" className="btn btn--outline" onClick={onRetry} disabled={checking}>
          {checking ? 'Checking' : 'Check again'}
        </button>
      )}
    </main>
  );
}
